import { initialize, reset, change } from 'redux-form';
import * as actItem from 'actions/library/item';
import * as act from 'actions';
import * as actNotif from 'actions/notifications';
import * as apiItem from 'api/libraries/items';
import * as apiSalesType from 'api/libraries/salesType';
import * as actSalesType from 'actions/library/salesType';
import { setFile, resetUploadImage } from 'actions/uploadImage';
import isFeatureEnabled from 'selectors/isFeatureEnabled';

function clearAllCustomCategoryFashionData(dispatch) {
  dispatch(actItem.unsetCustomCategoryFashionSizeAllDataNoSaga());
  dispatch(actItem.unsetCustomCategoryFashionColorAllDataNoSaga());
  dispatch(actItem.unsetCustomCategoryFashionMaterialAllDataNoSaga());
}

const ECOMMERCECATEGORYID = 166;

export function onClickRow(item) {
  return async (dispatch, getState) => {
    try {
      const itemReducer = getState().library.item;
      const isEnabledEcommerceAttributes = await isFeatureEnabled(
        getState(),
        'ecommerce-attributes'
      );

      const {
        ecommerceCategory,
        isRetail,
        rewardItemList,
        rewardCategoryList,
        rewardItemVariantOf,
        pointGainItemList,
        pointGainCategoryList,
        pointGainItemVariantOf,
      } = itemReducer;

      dispatch(reset('item'));
      dispatch(change('item', 'is_ecommerce', false));
      dispatch(change('modal_item_variants', 'custom_category_variant', false));
      dispatch(actItem.setItemDetail(null));
      dispatch(setFile(null));
      dispatch(act.showProgressBar());

      const { data: itemDetail } = isEnabledEcommerceAttributes
        ? await apiItem.getItemByIdV2(item.id)
        : await apiItem.getItemById(item.id);
      if (itemDetail && isRetail && isEnabledEcommerceAttributes) {
        const params = { page: 0, size: 1000 };
        const {
          data: { results: brandList },
        } = await apiItem.getBrandList(params, itemDetail.outlet_id);
        const itemBrand = {
          name: itemDetail.brand_name,
          id: itemDetail.brand_id,
        };
        let isFound = false;

        for (let i = 0; i < brandList.length; i++) {
          if (brandList[i].id === itemDetail.brand_id) {
            isFound = true;
            break;
          }
        }

        if (!isFound) {
          dispatch(actItem.setBrandList([...brandList, itemBrand]));
        } else {
          dispatch(actItem.setBrandList(brandList));
        }

        dispatch(
          actItem.setEcommerceCategoryFashion(
            ecommerceCategory.ecommerce_attributes
          )
        );
        const isEcommerceFashion =
          ecommerceCategory.google_category_id === ECOMMERCECATEGORYID;
        clearAllCustomCategoryFashionData(dispatch);
        if (itemDetail.is_ecommerce) {
          if (isEcommerceFashion) {
            for (let i = 0; i < itemDetail.item_variants.length; i++) {
              const jLength = itemDetail.item_variants[i]
                .item_variant_ecommerce_attributes
                ? itemDetail.item_variants[i].item_variant_ecommerce_attributes
                    .length
                : 0;
              for (let j = 0; j < jLength; j++) {
                const {
                  ecommerce_attribute_name: attributeName,
                } = itemDetail.item_variants[
                  i
                ].item_variant_ecommerce_attributes[j];
                let isEcommerceVariant = false;
                if (
                  !isEcommerceVariant &&
                  (attributeName === 'color' ||
                    attributeName === 'size' ||
                    attributeName === 'material')
                ) {
                  if (!isEcommerceVariant) {
                    itemDetail.item_variants[i].is_generated = true;
                    dispatch(
                      change(
                        'modal_item_variants',
                        'custom_category_variant',
                        true
                      )
                    );
                  }
                  isEcommerceVariant = true;
                }
              }
            }
          }
          itemDetail.item_variants[0].item_variant_ecommerce_attributes &&
            itemDetail.item_variants[0].item_variant_ecommerce_attributes.forEach(
              attr => {
                if (
                  attr.ecommerce_attribute_name === 'age' ||
                  attr.ecommerce_attribute_name === 'gender'
                ) {
                  itemDetail[attr.ecommerce_attribute_name] = {
                    id: attr.id,
                    value: attr.value,
                  };
                }
              }
            );
        } else {
          ecommerceCategory.ecommerce_attributes.map(attribute => {
            if (isEcommerceFashion && attribute.name === 'age') {
              itemDetail[attribute.name] = {
                id: attribute.id,
                name: attribute.name,
                value: 'All Ages',
              };
            }
            if (isEcommerceFashion && attribute.name === 'gender') {
              itemDetail[attribute.name] = {
                id: attribute.id,
                name: attribute.name,
                value: 'Unisex',
              };
            }
          });
          itemDetail.condition = 'New';
        }
        itemDetail.weight = {
          value: itemDetail.weight || '',
          unit: 'Gram (gr)',
          valueUniversal: 1,
        };
        itemDetail.dimension = {
          length: itemDetail.length || '',
          width: itemDetail.width || '',
          height: itemDetail.height || '',
          unit: 'Centimeter (cm)',
          valueUniversal: 1,
        };
      }
      // setting reward details
      itemDetail.is_reward_item = rewardItemList.indexOf(itemDetail.name) > -1;
      itemDetail.is_reward_category_item =
        rewardCategoryList.indexOf(itemDetail.category.name) > -1;
      itemDetail.item_variants.forEach(itemVariant => {
        itemVariant.is_reward_item_variant = rewardItemVariantOf[item.name]
          ? rewardItemVariantOf[item.name].indexOf(itemVariant.name) > -1
          : false;
      });

      // setting gain point details
      itemDetail.is_point_gain_item =
        pointGainItemList.indexOf(itemDetail.name) > -1;
      itemDetail.is_point_gain_category_item =
        pointGainCategoryList.indexOf(itemDetail.category.name) > -1;
      itemDetail.item_variants.forEach(itemVariant => {
        itemVariant.is_point_gain_item_variant = pointGainItemVariantOf[
          item.name
        ]
          ? pointGainItemVariantOf[item.name].indexOf(itemVariant.name) > -1
          : false;
      });

      dispatch(actItem.setItemDetail(itemDetail));
      const resSalesType = await apiSalesType.getSalesType({
        outletId: item.outlet_id,
        size: 9999,
        isAdvanceOrdering: true,
      });
      let salesType = resSalesType.data.content;
      salesType = salesType.filter(st => {
        return st.active_state;
      });
      dispatch(actSalesType.setListSalesType(salesType));
      const salesTypeIdList = salesType.map(st => st.id);

      const currentSalesType = [];
      if (itemDetail.is_sales_type_price) {
        salesType.forEach(st => {
          currentSalesType[st.id] = 0;
        });
      }
      if (
        itemDetail.active_modifiers === undefined ||
        itemDetail.active_modifiers === null
      ) {
        itemDetail.active_modifiers = [];
      }
      if (itemDetail.is_recipe === undefined || itemDetail.is_recipe === null) {
        itemDetail.is_recipe = false;
      }
      itemDetail.item_variants.map(function(iv) {
        if (
          iv.price === undefined &&
          (iv.is_variable_price === undefined || iv.is_variable_price === false)
        ) {
          iv.price = 0;
        }
        if (iv.in_stock === undefined) {
          iv.in_stock = 0;
        }
        if (iv.stock_alert === undefined) {
          iv.stock_alert = 0;
        }
        if (iv.position === undefined) {
          iv.position = 0;
        }
        if (iv.add_inventory === undefined) {
          iv.add_inventory = 0;
        }
        if (iv.track_stock === undefined) {
          iv.track_stock = false;
        }
        if (iv.alert === undefined) {
          iv.alert = false;
        }
        if (iv.has_cogs === undefined) {
          iv.has_cogs = false;
        } else if (iv.cogs === undefined || iv.cogs === null) {
          iv.cogs = 0;
        }
        if (iv.track_cogs === undefined) {
          iv.track_cogs = false;
        }
        if (iv.is_saved === undefined) {
          iv.is_saved = false;
        }
        if (iv.is_recipe === undefined) {
          iv.is_recipe = false;
        }
        if (
          isEnabledEcommerceAttributes &&
          isRetail &&
          iv.item_variant_ecommerce_attributes === null
        ) {
          iv.item_variant_ecommerce_attributes = [];
        }
        if (iv.sales_type_items !== undefined && iv.sales_type_items !== null) {
          iv.sales_type_items.forEach(salesTypeItem => {
            if (
              salesTypeItem.sales_type_price === undefined &&
              (salesTypeItem.is_variable_price === undefined ||
                salesTypeItem.is_variable_price === false)
            ) {
              salesTypeItem.sales_type_price = 0;
            }
          });
        } else {
          iv.sales_type_items = [];
        }
        // change price to string to handle redux form isDirty
        iv.price = iv.price || iv.price === 0 ? iv.price.toString() : iv.price;
        iv.is_editable = !iv.is_saved;
        iv.saved_cogs = !(!iv.has_cogs && !iv.track_cogs);
        if (itemDetail.is_sales_type_price) {
          iv.sales_type_items.forEach((sti, index) => {
            if (
              salesTypeIdList.indexOf(
                iv.sales_type_items[index].sales_type_id
              ) === -1
            ) {
              delete iv.sales_type_items[index];
            } else {
              currentSalesType[sti.sales_type_id]++;
            }
          });
        }
        return iv;
      });
      itemDetail.sales_type = salesType.map(st => {
        return { ...st, selected: currentSalesType[st.id] > 0 };
      });
      dispatch(initialize('item', { ...itemDetail }));
      dispatch(actItem.setMustScrollTop(true));
      dispatch(actItem.openRightColumn());
    } catch (error) {
      dispatch(actNotif.error(error.message));
    } finally {
      dispatch(act.hideProgressBar());
      dispatch(actItem.setMustScrollTop(false));
    }
  };
}

export function onClickCreateItem(outletId) {
  return async (dispatch, getState) => {
    const isEnabledEcommerceAttributes = await isFeatureEnabled(
      getState(),
      'ecommerce-attributes'
    );
    const state = getState();
    const { ecommerceCategory, isRetail } = state.library.item;

    dispatch(act.showProgressBar());
    dispatch(resetUploadImage());
    dispatch(change('modal_item_variants', 'custom_category_variant', false));

    try {
      const response = await apiItem.getNewItem();
      const responseData = response.data;
      let isClothing;
      responseData.active_modifiers = [];
      const resSalesType = await apiSalesType.getSalesType({
        outletId,
        size: 9999,
        isAdvanceOrdering: true,
      });
      if (isEnabledEcommerceAttributes && isRetail) {
        const params = { page: 0, size: 1000 };
        const brandList = await apiItem.getBrandList(params, outletId);
        dispatch(actItem.setBrandList(brandList.data.results));
        isClothing =
          ecommerceCategory.google_category_id === ECOMMERCECATEGORYID;
        if (isClothing) {
          dispatch(
            actItem.setEcommerceCategoryFashion(
              ecommerceCategory.ecommerce_attributes
            )
          );
          clearAllCustomCategoryFashionData(dispatch);
        }
        responseData.brand_id = null;
        responseData.images = [];
        ecommerceCategory.ecommerce_attributes.map(attribute => {
          if (isClothing && attribute.name === 'age') {
            responseData[attribute.name] = {
              id: attribute.id,
              name: attribute.name,
              value: 'All Ages',
            };
          }
          if (isClothing && attribute.name === 'gender') {
            responseData[attribute.name] = {
              id: attribute.id,
              name: attribute.name,
              value: 'Unisex',
            };
          }
        });
        responseData.condition = 'New';
        responseData.weight = {
          unit: 'Gram (gr)',
          valueUniversal: 1,
          value: '',
        };
        responseData.dimension = {
          length: '',
          width: '',
          height: '',
          unit: 'Centimeter (cm)',
          valueUniversal: 1,
        };
      }
      let salesType = resSalesType.data.content;
      salesType = salesType.filter(st => {
        return st.active_state;
      });
      dispatch(actSalesType.setListSalesType(salesType));
      responseData.sales_type = salesType.map(st => {
        return { ...st, selected: true };
      });
      if (responseData.active_modifiers === undefined) {
        responseData.active_modifiers = [];
      }
      if (responseData.is_recipe === undefined) {
        responseData.is_recipe = false;
      }
      responseData.item_variants.map(function(iv) {
        if (
          iv.price === undefined &&
          (iv.is_variable_price === undefined || iv.is_variable_price === false)
        ) {
          iv.price = 0;
        }
        if (iv.in_stock === undefined) {
          iv.in_stock = 0;
        }
        if (iv.stock_alert === undefined) {
          iv.stock_alert = 0;
        }
        if (iv.position === undefined) {
          iv.position = 0;
        }
        if (iv.add_inventory === undefined) {
          iv.add_inventory = 0;
        }
        if (iv.track_stock === undefined) {
          iv.track_stock = false;
        }
        if (iv.alert === undefined) {
          iv.alert = false;
        }
        if (iv.has_cogs === undefined) {
          iv.has_cogs = false;
        } else if (iv.cogs === undefined) {
          iv.cogs = 0;
        }
        if (iv.track_cogs === undefined) {
          iv.track_cogs = false;
        }
        if (iv.is_saved === undefined) {
          iv.is_saved = false;
        }
        if (iv.is_recipe === undefined) {
          iv.is_recipe = false;
        }
        if (isClothing && iv.item_variant_ecommerce_attributes === null) {
          iv.item_variant_ecommerce_attributes = [];
        }
        if (iv.sales_type_items !== undefined) {
          iv.sales_type_items.forEach(salesTypeItem => {
            if (
              salesTypeItem.sales_type_price === undefined &&
              (salesTypeItem.is_variable_price === undefined ||
                salesTypeItem.is_variable_price === false)
            ) {
              salesTypeItem.sales_type_price = 0;
            }
          });
        } else {
          iv.sales_type_items = [];
        }
        iv.price = iv.price || iv.price === 0 ? iv.price.toString() : iv.price;
        iv.is_editable = !iv.is_saved;
        iv.saved_cogs = !(!iv.has_cogs && !iv.track_cogs);
        return iv;
      });
      if (responseData.item_variants.length < 1) {
        responseData.item_variants.push({
          name: '',
          price: null,
          sku: '',
          in_stock: 0,
          stock_alert: 0,
          cogs: null,
          saved_cogs: false,
          is_saved: false,
          is_editable: true,
          is_new: true,
          is_generated: isClothing ? false : null,
          item_variant_ecommerce_attributes: isClothing ? [] : null,
        });
      }
      dispatch(actItem.setItemDetail(responseData));
      dispatch(actItem.setMustScrollTop(true));
      dispatch(actItem.openRightColumn());
      dispatch(initialize('item', responseData));
    } catch (error) {
      dispatch(actNotif.error(error.message));
    } finally {
      dispatch(act.hideProgressBar());
      dispatch(actItem.setMustScrollTop(false));
    }
  };
}
